var objActivityValidation = {
    /// <summary>
    /// This object contains all functions for the client-side validation of activity edit fields.
    /// </summary>


    _validate: function (me) {
        /// <summary> 
        /// everything is validated and save button state is set
        /// </summary >
        var bError = false;
        try {
            if (me.error) { return false; }

            // we check the mandatory fields and the time relation
            if (!objActivityValidation._validateTimeTextbox(me, "#div-start-time-wrapper", me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime)) bError = true;
            if (!objActivityValidation._validateTimeTextbox(me, "#div-end-time-wrapper", me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime)) bError = true;           
            if (!bError) { // check time relation only if both fields are formally valid
                if (!objActivityValidation._validateTimeRelation(me)) bError = true;
            }

            if (!objActivityValidation._validateDescription(me)) bError = true;
            if (!objActivityValidation._validateTicket(me)) bError = true;
            if (!objActivityValidation._validateUser(me)) bError = true;
            if (!objActivityValidation._validateNumberTextbox(me, "#div-txt-field-km", me.myHtml.activityEdit.editArea.middleArea.statusBox.txtKm)) bError = true;
            if (!objActivityValidation._validateNumberTextbox(me, "#div-txt-travel-time", me.myHtml.activityEdit.editArea.middleArea.statusBox.txtTravelTime)) bError = true;
            objActivityEdit._clearSaveState(me);
            objActivityValidation._updateSaveButtonStatus(me, bError);
            return !bError;

        } catch (e) { me._writeErr(e); return false; }
    },

    _isTicketValid: function (me) {
        /// <summary>
        /// Checks if ticket selection is valid (called from _updateSaveButtonStatus)
        /// </summary >
        try {

            if (me.specific.mandatoryTicketActivity) {

                // no ticket selected -> ok
                var noTicket = me.fnd("#chb-no-ticket").is(":checked");
                if (noTicket) return true;

                // otherwise a ticket must be selected
                var sel = me.selectedTicketId;
                return (Number.isInteger(sel) && sel > 0);
            }
            else
                return true;


        } catch (e) { me._writeErr(e); return false; }
    },


    _validateTimeTextbox: function (me, wrapperSelector, input) {
        try {
            var val = (input && input.val) ? String(input.val()).trim() : "";
            var wrap = me.fnd(wrapperSelector);

            if (val.length === 0) {
                objActivityValidation._setInvalid(wrap, (me.specific.resources.ERR_inputInvalid || "Pflichtfeld"));
                return false;
            }

            var hasColon = val.indexOf(":") !== -1;
            var digits = val.replace(/\D/g, "");
            if (!hasColon && digits.length > 0 && digits.length < 3) {
                objActivityValidation._setNeutral(wrap);
                return true;
            }

            var norm = objActivityValidation._normalizeTimeSmart(val);
            if (!norm) {
                objActivityValidation._setInvalid(wrap, "Zeitformat HH:MM");
                return false;
            }

            if (input && input.val) { input.val(norm); }
            objActivityValidation._setValid(wrap);
            return true;

        } catch (e) { me._writeErr(e); return false; }
    },



    _validateTimeRelation: function (me) {
        /// <summary>
        /// Checks if start time is before end time, otherwise marks both fields as invalid
        /// </summary >
        try {
            var s = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime.val().trim();
            var e = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime.val().trim();
            var ws = me.fnd("#div-start-time-wrapper");
            var we = me.fnd("#div-end-time-wrapper");

            if (!s || !e) return true; // if relation is not checkable, do nothing (other validation should mark empty fields)

            var fmt = /^([01]\d|2[0-3]):([0-5]\d)$/;
            if (!fmt.test(s) || !fmt.test(e)) return true;

            var sm = objActivityValidation._toMinutes(s);
            var em = objActivityValidation._toMinutes(e);

            if (sm > em) {
                objActivityValidation._setInvalid(ws, "Startzeit > Endzeit");
                objActivityValidation._setInvalid(we, "Endzeit < Startzeit");
                return false;
            } else {
                objActivityValidation._setValid(ws);
                objActivityValidation._setValid(we);
                return true;
            }
        } catch (e) { me._writeErr(e); return false; }
    },


    _validateDescription: function (me) {
        /// <summary>
        /// Checks if description is not empty (after stripping HTML)
        /// </summary >
        try {
            var wrap = me.fnd("#div-editor");
            var raw = me.descriptionText || ""; 
            var txt = objActivityValidation._stripHtml(raw).trim();

            if (txt.length === 0) {
                objActivityValidation._setInvalid(wrap, me.specific.resources.description + " " + (me.specific.resources.ERR_inputInvalid));
                return false;
            }

            objActivityValidation._setValid(wrap);
            return true;

        } catch (e) { me._writeErr(e); return false; }
    },

    _validateTicket: function (me) {
        /// <summary>
        /// Checks if a ticket is selected (mandatory selection, except for "no ticket" is checked)
        /// </summary>
        try {

                var wrap = me.fnd("#div-ticket-list-wrapper");
                var list = me.fnd("#div-ticket-list");
                var cap = wrap.find(".caption").first();

                cap.css({ display: "flex", "align-items": "center" });

                var noTicket = me.fnd("#chb-no-ticket").is(":checked");
                var selected = me.selectedTicketId;
                var ok = !me.specific.mandatoryTicketActivity ? true : (!!noTicket || (Number.isInteger(selected) && selected > 0) );

                var icon = cap.find(".validation-icon");
                if (icon.length === 0) {
                    icon = $("<span>").addClass("validation-icon").css({ "margin-left": "auto" });
                    cap.append(icon);
                }
                else {
                    icon.css({ "margin-left": "auto" });
                }

                if (ok) {
                    list.css({ "border-color": "transparent" });
                    if (me.specific.mandatoryTicketActivity) {
                        icon.html("<i class='fa fa-check icon-color-ok'></i>").attr("title", "");
                        me.fnd("#div-ticket-no-ticket-row").addClass("vc-grid-margin-bottom");
                    }
                    else {
                        icon.empty().attr("title", "");
                        me.fnd("#div-ticket-no-ticket-row").addClass("vc-grid-margin-bottom");
                    }
                } else {
                    const errorColor = objActivityValidation._getColorFromClass("icon-color-error");
                    list.css({ "border-color": errorColor });
                    icon.html("<i class='fa-regular fa-times-circle icon-color-error'></i>").attr("title", (me.specific.resources.tickets) + ": " + (me.specific.resources.ERR_inputInvalid));
                }

                objActivityValidation._updateSaveButtonStatus(me, false);
                return ok;


        } catch (e) { me._writeErr(e); return false; }
    },

    _getColorFromClass: function(className) {
        const tmp = $("<span>").addClass(className).css({ position: "absolute", visibility: "hidden", pointerEvents: "none" }).appendTo(document.body);
        const color = getComputedStyle(tmp[0]).color;
        tmp.remove();
        return color;
    },


    _validateUser: function (me) {
        /// <summary>
        /// Checks if a user is selected (if user selection is visible)
        /// </summary >
        try {
            var wrap = me.fnd("#div-ddl-users");

            // if user selection is not visible, we do not validate
            if (!wrap.is(":visible")) {
                objActivityValidation._setValid(wrap);
                return true;
            }

            var val = (me.ddlUsers && me.ddlUsers.getValue) ? parseInt(me.ddlUsers.getValue(), 10) : -1;
            var ok = Number.isInteger(val) && val > 0;

            if (ok) {
                objActivityValidation._setValid(wrap);
            } else {
                var tUser = (me.specific.resources.user || "User");
                var tReq = (me.specific.resources.ERR_inputInvalid);
                objActivityValidation._setInvalid(wrap, tUser + " " + tReq);
            }
            return ok;

        } catch (e) { me._writeErr(e); return false; }
    },

    _validateNumberTextbox: function (me, wrapperSelector, input) {
        /// <summary> 
        /// Checks if the entry in number fields is correct
        /// </summary >
        try {
            var val = (input && input.val) ? String(input.val()).trim() : "";
            var wrap = me.fnd(wrapperSelector);

            if (val.length === 0) {
                objActivityValidation._setInvalid(wrap, "Eingabe erforderlich");
                return false;
            }

            var ok = /^\d+(,\d+)?$/.test(val);
            if (!ok) {
                objActivityValidation._setInvalid(wrap, "Nur Zahl (z. B. 3 oder 3,1)");
                return false;
            }

            objActivityValidation._setValid(wrap);
            return true;

        } catch (e) { me._writeErr(e); return false; }
    },

    _updateSaveButtonStatus: function (me, bError) {
        /// <summary>
        /// Checks if there are any invalid fields and enables/disables the save button
        /// </summary >
        try {
            var ticketOk = objActivityValidation._isTicketValid(me); // we check if ticket selection is ok
            var anyInvalid = !!bError || (me.fnd(".formItemInvalid:visible", me.myHtml.activityEdit).length > 0) || !ticketOk;
            var save = me.myHtml.activityEdit && me.myHtml.activityEdit.menu && me.myHtml.activityEdit.menu.btnSave ? me.myHtml.activityEdit.menu.btnSave : $();

            var saveExistsInDom = save && save.length && document.body.contains(save[0]);
            var isUiButton = saveExistsInDom && !!(save.data("uiButton") || save.hasClass("ui-button"));

            if (anyInvalid) {
                objActivityEdit._setStateError(me, ("* " + me.specific.resources.inputIncomplete));
                if (isUiButton) {
                    save.button("disable");
                } else if (saveExistsInDom) {
                    save.prop("disabled", true).addClass("ui-state-disabled");
                }
            } else {
                objActivityEdit._setStateClear(me);
                if (isUiButton) {
                    save.button("enable");
                } else if (saveExistsInDom) {
                    save.prop("disabled", false).removeClass("ui-state-disabled");
                }
            }
            return !anyInvalid;
        } catch (e) { me._writeErr(e); return false; }
    },

    _setValid: function (wrap) {
        /// <summary>
        /// sets a form item to valid
        /// </summary >
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemInvalid").addClass("formItemValid");
        objActivityValidation._setIcon(wrap, true, "");
    },

    _setInvalid: function (wrap, title) {
        /// <summary>
        /// sets a form item to invalid
        /// </summary >
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemValid").addClass("formItemInvalid");
        objActivityValidation._setIcon(wrap, false, title || "");
    },

    _setIcon: function (wrap, ok, title) {
        /// <summary>
        /// Sets the validation icon (ok or error) and the corresponding tooltip title
        /// </summary >
        var id = "img-validation-" + (wrap.attr("id") || Math.random().toString(36).slice(2));
        var spot = wrap.find("#" + id);
        if (spot.length === 0) {
            spot = $("<span>").attr("id", id).addClass("validation-icon").css({ float: "right", "margin-top": "2px" });
            var cap = wrap.find(".caption").first();
            if (cap.length) cap.append(spot); else wrap.append(spot);
        }
        spot.attr("title", title || "");
        spot.html(ok ? "<i class='fa fa-check icon-color-ok'></i>" : "<i class='fa-regular fa-times-circle icon-color-error'></i>");
    },

    _toMinutes: function (t) {
        /// <summary>
        /// converts a time string HH:MM to minutes
        /// </summary >
        var sp = t.split(":");
        return parseInt(sp[0], 10) * 60 + parseInt(sp[1], 10);
    },

    _normalizeTime: function (t) {
        if (!t) return null;
        t = String(t).trim();
        var m = /^([0-1]?\d|2[0-3]):([0-5]\d)$/.exec(t);
        if (!m) return null;
        var hh = m[1].padStart(2, "0");
        var mm = m[2]; 
        return hh + ":" + mm;
    },

    _normalizeTimeFromDigits: function (digits) {
        if (!/^\d+$/.test(digits)) return null;
        if (digits.length === 1) {               // "5" -> 05:00
            return "0" + digits + ":00";
        }
        if (digits.length === 2) {               // "15" -> 15:00
            var hh = parseInt(digits, 10);
            if (hh > 23) return null;
            return String(hh).padStart(2, "0") + ":00";
        }
        if (digits.length === 3) {               // "750" -> 07:50
            var hh3 = parseInt(digits[0], 10);
            var mm3 = parseInt(digits.slice(1), 10);
            if (hh3 > 23 || mm3 > 59) return null;
            return String(hh3).padStart(2, "0") + ":" + String(mm3).padStart(2, "0");
        }
        if (digits.length === 4) {               // "1000" -> 10:00
            var hh4 = parseInt(digits.slice(0, 2), 10);
            var mm4 = parseInt(digits.slice(2), 10);
            if (hh4 > 23 || mm4 > 59) return null;
            return String(hh4).padStart(2, "0") + ":" + String(mm4).padStart(2, "0");
        }
        return null;
    },


    _normalizeTimeSmart: function (t) {
        if (!t) return null;
        t = String(t).trim();

        var m = /^([0-1]?\d|2[0-3]):([0-5]\d)$/.exec(t);
        if (m) {
            var hh = m[1].padStart(2, "0");
            var mm = m[2];
            return hh + ":" + mm;
        }

        var digits = t.replace(/\D/g, "");
        if (digits.length === 0) return null;
        return objActivityValidation._normalizeTimeFromDigits(digits);
    },

    _setNeutral: function (wrap) {
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemValid formItemInvalid");
        var ic = wrap.find(".validation-icon");
        if (ic.length) ic.empty().attr("title", "");
    },

    _stripHtml: function (html) {
        /// <summary>
        /// converts HTML to plain text
        /// </summary >
        var div = document.createElement("div");
        div.innerHTML = (html || "");
        return (div.textContent || div.innerText || "");
    }

};